export default "__VITE_ASSET__C8JEQlQc__"